import { Tooltip } from "@progress/kendo-react-tooltip";
import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { INavigation } from "@/configs/menu";

interface SidebarItemProps {
  item: INavigation;
  expanded: boolean;
  isActive: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  item,
  expanded,
  isActive,
}) => {
  const { t } = useTranslation();
  const { Icon, text, textKey, route, isPreview } = item;
  const resolvedText = textKey ? t(textKey) : (text ?? "");

  const content = (
    <Link
      to={route}
      className={classNames("tlx-v4-sidebar-item", {
        "tlx-v4-sidebar-item--active": isActive,
      })}
    >
      <div className="tlx-v4-sidebar-item-icon">
        {Icon && <Icon width={16} height={16} />}
      </div>
      {expanded && (
        <span className="tlx-v4-sidebar-item-text">
          {resolvedText}
          {isPreview && (
            <span className="tlx-v4-sidebar-item-preview">Preview</span>
          )}
        </span>
      )}
    </Link>
  );

  if (!expanded) {
    return (
      <Tooltip anchorElement="target" position="right" parentTitle>
        <div title={resolvedText}>{content}</div>
      </Tooltip>
    );
  }

  return content;
};

export default SidebarItem;
